let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eR1jz")).then(() => parcelRequire('khyHB'));